/*
This file is located in the main branch
Last time the file was updated (UTC): [05.03.2024 14:56:25]
Permissions to update outside the main branch: [true]
*/

import { MenuItemType } from 'providers/SidebarProvider';
import { AiOutlineForm, AiOutlineInbox } from 'react-icons/ai';
import { BiBlock, BiBookBookmark } from 'react-icons/bi';
import {
    BsBook,
    BsClipboardCheck,
    BsFileDiff,
    BsFillFileEarmarkDiffFill,
    BsGraphUp,
} from 'react-icons/bs';
import { FaHistory } from 'react-icons/fa';
import { FiPercent, FiSettings, FiUser, FiUsers } from 'react-icons/fi';
import { GoDiff, GoOrganization } from 'react-icons/go';
import {
    MdAnalytics,
    MdDashboard,
    MdOutlinePayments,
    MdOutlinePendingActions,
    MdOutlineTranslate,
    MdPeople,
} from 'react-icons/md';
import { RiBillLine, RiListSettingsLine, RiProfileFill, RiStore3Fill } from 'react-icons/ri';
import { VscSortPrecedence } from 'react-icons/vsc';

export const sidebarEmployerPortalUserMenu: MenuItemType[] = [
    {
        id: 'dashboard',
        value: 'BackOfficeDashboard',
        icon: <MdDashboard />,
        link: '/dashboard',
        role: 'dashboardGet',
    },
    {
        id: 'employees',
        value: 'BackOfficeEmployees',
        icon: <MdPeople />,
        link: '/employees',
        role: 'employeeGet',
    },
    {
        id: 'history',
        value: 'BackOfficeHistoryOfUploadedFiles',
        icon: <BsFillFileEarmarkDiffFill />,
        link: '/history',
        role: 'employeesHistoryGet',
    },
    {
        id: 'analytics',
        value: 'BackOfficeAnalytics',
        icon: <MdAnalytics />,
        link: '/analytics',
        role: 'reportsGet',
    },
    {
        id: 'profile',
        value: 'BackOfficeProfile',
        icon: <RiProfileFill />,
        link: '/profile',
        role: 'employerProfileGet',
    },
];

export const sidebarMenu: MenuItemType[] = [
    {
        id: 'reports',
        value: 'BackOfficeReports',
        icon: <BsGraphUp />,
        link: '/reports',
        role: 'reportsGet',
    },
    {
        id: 'payments',
        value: 'BackOfficePayments',
        icon: <MdOutlinePayments />,
        link: '/payments',
        role: 'paymentsGet',
    },
    {
        id: 'smsLog',
        value: 'BackOfficeSmsLogs',
        icon: <MdOutlinePendingActions />,
        link: '/smslog',
        role: 'smslogGet',
    },
    {
        value: 'BackOfficeAdministration',
        icon: <RiBillLine />,
        link: '',
        childs: [
            {
                id: 'brands',
                value: 'BackOfficeBrands',
                icon: <BsBook />,
                link: '/brands',
                role: 'brandsGet',
            },
            {
                id: 'tradeOrgs',
                value: 'BackOfficeTradeOrgs',
                icon: <GoOrganization />,
                link: '/tradeorgs',
                role: 'tradeOrgsGet',
            },
            {
                id: 'outlets',
                value: 'BackOfficeOutlets',
                icon: <RiStore3Fill />,
                link: '/outlets',
                role: 'outletsGet',
            },
            {
                id: 'prescoring',
                value: 'BackOfficePrescoring',
                icon: <VscSortPrecedence />,
                link: '/prescr',
                role: 'prescrGet',
            },
            {
                id: 'scoring_settings',
                value: 'BackOfficeScoringOptions',
                icon: <FiSettings />,
                link: '/scoringsettings',
                role: 'scoringSettingsGet',
            },
            {
                id: 'scoring_client_questionary',
                value: 'BackOfficeClientQuestionary',
                icon: <AiOutlineForm />,
                link: '/questionary',
                role: 'questionaryGet',
            },
            {
                value: 'BackOfficeBilling',
                icon: <RiBillLine />,
                link: '',
                childs: [
                    {
                        id: 'tariffs',
                        value: 'BackOfficeTariffs',
                        icon: <BsFileDiff />,
                        link: '/tariffs',
                        role: 'tariffsGet',
                    },
                    {
                        id: 'billing_tarrif_groups',
                        value: 'BackOfficeTariffGroups',
                        icon: <GoDiff />,
                        link: '/tariffgroups',
                        role: 'tariffgroupsGet',
                    },
                    {
                        id: 'billing_tariff_procedure_params',
                        value: 'BackOfficeParamSetsForProcedures',
                        icon: <RiListSettingsLine />,
                        link: '/tariffprocedureparams',
                        role: 'tariffProcedureParamsGet',
                    },
                    {
                        id: 'billing_service_discount',
                        value: 'BackOfficeServiceDiscount',
                        icon: <FiPercent />,
                        link: '/servicediscount',
                        role: 'serviceDiscountGet',
                    },
                ],
            },
            {
                value: 'BackOfficeOther',
                icon: <AiOutlineInbox />,
                link: '',
                childs: [
                    {
                        id: 'other_order_statuses',
                        value: 'BackOfficeOrderStatuses',
                        icon: <BsClipboardCheck />,
                        link: '/orderstatus',
                        role: 'orderstatusGet',
                    },
                    {
                        id: 'other_user_logs',
                        value: 'BackOfficeUserActionLogs',
                        icon: <MdOutlinePendingActions />,
                        link: '/useractionlog',
                        role: 'actionlogGet',
                    },
                    {
                        id: 'other_dicts',
                        value: 'BackOfficeDicts',
                        icon: <BiBookBookmark />,
                        link: '/dictionary',
                        role: 'dictionaryGet',
                    },
                    {
                        id: 'other_translator',
                        value: 'BackOfficeTranslator',
                        icon: <MdOutlineTranslate />,
                        link: '/translation',
                        role: 'translatorGet',
                    },
                    {
                        id: 'other_settings',
                        value: 'BackOfficeSettings',
                        icon: <FiSettings />,
                        link: '/settings',
                        role: 'websettingsGet',
                    },
                    {
                        id: 'other_histTables',
                        value: 'BackOfficeHistoryTables',
                        icon: <FaHistory />,
                        link: '/histtables',
                        role: 'histtableGet',
                    },
                    {
                        id: 'other_declinedshowcase',
                        value: 'BackOfficeShowcaseSettingsForRefuseniks',
                        icon: <BiBlock />,
                        link: '/declinedshowcase',
                        role: 'declinedShowcasesGet',
                    },
                ],
            },
            {
                id: 'users',
                value: 'BackOfficeUsers',
                icon: <FiUser />,
                link: '/users',
                role: 'accountsGet',
            },
            {
                id: 'roles',
                value: 'BackOfficeRoles',
                icon: <FiUsers />,
                link: '/roles',
                role: 'rolesGet',
            },
        ],
    },
];
